import React, { useState } from 'react';
import { FaleComRH } from './FaleComRH';
import { Chat } from './Chat';

interface Chamado {
  id: string;
  codigo: string;
  descricao: string;
  categoria: string;
  usuario: {
    nome: string;
    email: string;
    avatar: string;
  };
  atendente: {
    nome: string;
    status: string;
  };
  status: string;
  prioridade: string;
  ultimaAtualizacao: string;
  criado: string;
  mensagens: any[];
}

export const FaleComRHContainer: React.FC = () => {
  const [selectedChamado, setSelectedChamado] = useState<Chamado | null>(null);

  const handleChamadoClick = (chamado: Chamado) => {
    setSelectedChamado(chamado);
  };

  const handleBackToList = () => {
    setSelectedChamado(null);
  };

  if (selectedChamado) {
    return <Chat chamado={selectedChamado} onBack={handleBackToList} />;
  }

  return <FaleComRH onChamadoClick={handleChamadoClick} />;
};
